import { render } from "./iran-cities.vue?vue&type=template&id=0209fac6"
import script from "./iran-cities.vue?vue&type=script&lang=js"
export * from "./iran-cities.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__